import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLinebreak: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLinebreak"><Path fillRule="evenodd" clipRule="evenodd" d="M3 4H21V5.5H3V4ZM3 11.25H16.875C19.2912 11.25 21.25 13.2088 21.25 15.625C21.25 18.0412 19.2912 20 16.875 20H13.5607L15.3107 21.75L14.25 22.8107L11.4393 20H11.4332V19.9939L10.6893 19.25L11.4332 18.5061V18.5H11.4393L14.25 15.6893L15.3107 16.75L13.5607 18.5H16.875C18.4628 18.5 19.75 17.2128 19.75 15.625C19.75 14.0372 18.4628 12.75 16.875 12.75H3V11.25ZM3 18.5H8V20H3V18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLinebreak;
